import *  as service from '../services/PianoTechAppointmentServices';

export const FETCH_PIANOTECHAPPOINTMENT_LIST_STARTED = 'FETCH_PIANOTECHAPPOINTMENT_LIST_STARTED';
export const FETCH_PIANOTECHAPPOINTMENT_LIST_SUCCEEDED = 'FETCH_PIANOTECHAPPOINTMENT_LIST_SUCCEEDED';
export const FETCH_PIANOTECHAPPOINTMENT_LIST_FAILED = 'FETCH_PIANOTECHAPPOINTMENT_LIST_FAILED';
export const FIND_PIANOTECHAPPOINTMENT_STARTED = 'FIND_PIANOTECHAPPOINTMENT_STARTED';
export const FIND_PIANOTECHAPPOINTMENT_SUCCEEDED = 'FIND_PIANOTECHAPPOINTMENT_SUCCEEDED';
export const FIND_PIANOTECHAPPOINTMENT_FAILED = 'FIND_PIANOTECHAPPOINTMENT_FAILED';
export const SAVE_PIANOTECHAPPOINTMENT_STARTED = 'SAVE_PIANOTECHAPPOINTMENT_STARTED';
export const SAVE_PIANOTECHAPPOINTMENT_SUCCEEDED = 'SAVE_PIANOTECHAPPOINTMENT_SUCCEEDED';
export const SAVE_PIANOTECHAPPOINTMENT_FAILED = 'SAVE_PIANOTECHAPPOINTMENT_FAILED';
export const RETURN_TO_PIANOTECHAPPOINTMENT_LIST = 'RETURN_TO_PIANOTECHAPPOINTMENT_LIST';
export const SWITCH_EDIT_TYPE = 'SWITCH_EDIT_TYPE';
export const PIANOTECHAPPOINTMENT_MODIFIED = 'PIANOTECHAPPOINTMENT_MODIFIED';
export const PIANOTECHAPPOINTMENT_VALIDATE = 'PIANOTECHAPPOINTMENT_VALIDATE';
export const FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_STARTED = 'FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_STARTED';
export const FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_SUCCEEDED = 'FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_SUCCEEDED';
export const FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_FAILED = 'FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_FAILED';
export const PIANOTECHAPPOINTMENT_UPDATE_COMPLETE = 'PIANOTECHAPPOINTMENT_UPDATE_COMPLETE';

function fetchPianoTechAppointmentListSucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechAppointmentList = jsonResponse.pianoTechAppointmentList;

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: FETCH_PIANOTECHAPPOINTMENT_LIST_FAILED,
            message: errorMessage,
        }
    }

    return {
        type: FETCH_PIANOTECHAPPOINTMENT_LIST_SUCCEEDED,
        pianoTechAppointmentList
    }
}

function fetchPianoTechAppointmentListFailed(response) {
    const errorMessage = 'Failed to retrieve PianoTechAppointment list.';

    return {
        type: FETCH_PIANOTECHAPPOINTMENT_LIST_FAILED,
        message: errorMessage
    }
}

export function fetchPianoTechAppointmentList() {
    return dispatch => {

        dispatch({
            type: FETCH_PIANOTECHAPPOINTMENT_LIST_STARTED
        });

        service
            .getPianoTechAppointmentList()
            .then(resp => {
                dispatch(fetchPianoTechAppointmentListSucceeded(resp))
            })
            .catch(error => {
                dispatch(fetchPianoTechAppointmentListFailed(error))
            });
    }
}

function findPianoTechAppointmentSucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechAppointment = jsonResponse.pianoTechAppointment;
    const originalPianoTechAppointment = Object.assign({}, pianoTechAppointment);

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: FIND_PIANOTECHAPPOINTMENT_FAILED,
            message: errorMessage,
        }
    }

    return {
        type: FIND_PIANOTECHAPPOINTMENT_SUCCEEDED,
        pianoTechAppointment,
        originalPianoTechAppointment,
    }
}

function findPianoTechAppointmentFailed(response) {
    const errorMessage = 'Failed to find PianoTechAppointment.';

    return {
        type: FIND_PIANOTECHAPPOINTMENT_FAILED,
        message: errorMessage
    }
}

export function findPianoTechAppointment(appointmentId) {
    return dispatch => {

        service
            .findPianoTechAppointment(appointmentId)
            .then(resp => {
                dispatch(findPianoTechAppointmentSucceeded(resp))
            })
            .catch(error => {
                dispatch(findPianoTechAppointmentFailed(error))
            });
    }
}

function savePianoTechAppointmentSucceeded(response, pianoTechAppointment) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const message = 'PianoTechAppointment ' + pianoTechAppointment.maintenanceType + ' Successful.';
    let updatedPianoTechAppointment = pianoTechAppointment;

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: SAVE_PIANOTECHAPPOINTMENT_FAILED,
            message: errorMessage,
        }
    }

    if (jsonResponse.pianoTechAppointment) {
        updatedPianoTechAppointment = jsonResponse.pianoTechAppointment;
    }

    const pianoTechAppointmentList = jsonResponse.pianoTechAppointmentList || [];

    return {
        type: SAVE_PIANOTECHAPPOINTMENT_SUCCEEDED,
        pianoTechAppointment: updatedPianoTechAppointment,
        message,
        pianoTechAppointmentList,
    }
}

function savePianoTechAppointmentFailed(response) {
    const errorMessage = 'Action failed: ' + response.message;

    return {
        type: SAVE_PIANOTECHAPPOINTMENT_FAILED,
        message: errorMessage
    }
}

export function savePianoTechAppointment(pianoTechAppointment) {
    return dispatch => {

        service
            .savePianoTechAppointment(pianoTechAppointment)
            .then(resp => {
                dispatch(savePianoTechAppointmentSucceeded(resp, pianoTechAppointment))
            })
            .catch(error => {
                dispatch(savePianoTechAppointmentFailed(error))
            });
    }
}

export function fetchPianoTechAppointmentListForCompanyFromDateStarted() {
    return {
        type: FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_STARTED,
    }
}

export function fetchPianoTechAppointmentListForCompanyFromDateSucceeded(pianoTechAppointmentList) {
    return {
        type: FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_SUCCEEDED,
        pianoTechAppointmentList,
    }
}

export function fetchPianoTechAppointmentListForCompanyFromDateFailed(errorMessage) {
    return {
        type: FETCH_PIANOTECHAPPOINTMENT_LIST_FOR_COMPANY_FROM_DATE_FAILED,
        message: errorMessage,
    }
}

export function fetchPianoTechAppointmentListForCompanyFromDate(companyId, startingDate) {
    return dispatch => {
        dispatch(fetchPianoTechAppointmentListForCompanyFromDateStarted());

        service
            .getPianoTechAppointmentListForCompanyFromDate(companyId, startingDate)
            .then(resp => {
                const pianoTechAppointmentList = resp.data.pianoTechAppointmentList || [];
                dispatch(fetchPianoTechAppointmentListForCompanyFromDateSucceeded(pianoTechAppointmentList));
            })
            .catch(error => {
                dispatch(fetchPianoTechAppointmentListForCompanyFromDateFailed(error.message));
            });
    }
}

